module.exports = __webpack_public_path__ + "static/media/Resource2.bc4548ff.png";